module.exports = __webpack_public_path__ + "static/ps-telefon-66b3de8761e0fb3c86a84b0f2ca0db7d.png";